import React from 'react'
import { Image } from 'semantic-ui-react'
import styles from './logo.module.css'
import logo from '../../images/logo_title_white.svg'
import { history } from '../../redux/store'

const Logo = () => (
  <Image
    onClick={() => history.push('/product')}
    className={styles.logo}
    size="small"
    src={logo}
  />
)

export default Logo
